<template>
    <v-dialog v-model="dialog" max-width="1200px" persistent scrollable>
        <v-card>
            <v-card-title class="primary white--text">
                <v-icon left color="white">settings</v-icon>
                Gestione Tipologie Scadenze
            </v-card-title>

            <v-divider />

            <v-card-text class="pa-0">
                <!-- Toolbar azioni -->
                <v-toolbar flat dense color="grey lighten-4">
                    <v-btn color="primary" @click="nuovaTipologia">
                        <v-icon left>add</v-icon>
                        Nuova Tipologia
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-text-field v-model="ricerca" append-icon="search" label="Cerca" single-line hide-details dense
                        clearable class="mr-2" style="max-width: 300px" />
                </v-toolbar>

                <!-- Tabella tipologie -->
                <v-data-table :headers="headers" :items="tipologieFiltrate" :loading="loading"
                    :sort-by="['categoria', 'nome']" :sort-desc="[false, false]" class="elevation-0" dense
                    hide-default-footer disable-pagination>

                    <template v-slot:item.icona="{ item }">
                        <v-icon :color="item.coloreHex" class="material-symbols-outlined">
                            {{ item.iconaMaterial }}</v-icon>
                    </template>

                    <!-- <template v-slot:item.nome="{ item }">
                        <div class="d-flex align-center">
                            <div>
                                <div class="font-weight-medium">{{ item.nome }}</div>
                                <div class="text-caption grey--text">{{ item.categoria }}</div>
                            </div>
                        </div>
                    </template> -->

                    <template v-slot:item.ricorrenzaMesiDefault="{ item }">
                        <span v-if="item.ricorrenzaMesiDefault">
                            {{ item.ricorrenzaMesiDefault }}
                            {{ item.ricorrenzaMesiDefault === 1 ? 'mese' : 'mesi' }}
                        </span>
                        <span v-else class="grey--text">Una tantum</span>
                    </template>

                    <template v-slot:item.campiRichiesti="{ item }">
                        <v-chip v-for="campo in parseCampiRichiesti(item.campiRichiesti)" :key="campo" x-small
                            class="mr-1">
                            {{ getCampoLabel(campo) }}
                        </v-chip>
                        <span v-if="parseCampiRichiesti(item.campiRichiesti).length === 0" class="grey--text">
                            Nessuno
                        </span>
                    </template>

                    <template v-slot:item.azioni="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon small color="primary" v-on="on" @click="modificaTipologia(item)">
                                    <v-icon small>edit</v-icon>
                                </v-btn>
                            </template>
                            <span>Modifica</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon small color="info" v-on="on" @click="duplicaTipologia(item)">
                                    <v-icon small>content_copy</v-icon>
                                </v-btn>
                            </template>
                            <span>Duplica</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon small color="error" v-on="on" @click="confermaEliminazione(item)">
                                    <v-icon small>delete</v-icon>
                                </v-btn>
                            </template>
                            <span>Elimina</span>
                        </v-tooltip>
                    </template>

                    <template v-slot:no-data>
                        <div class="text-center py-8">
                            <v-icon size="64" color="grey lighten-1">folder_open</v-icon>
                            <div class="text-h6 mt-4 grey--text">Nessuna tipologia trovata</div>
                        </div>
                    </template>
                </v-data-table>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-spacer />
                <v-btn text @click="chiudi">Chiudi</v-btn>
            </v-card-actions>
        </v-card>

        <!-- Dialog Form Tipologia -->
        <tipologia-form-dialog v-model="dialogForm" :tipologia="tipologiaCorrente" @saved="onTipologiaSalvata"
            @close="dialogForm = false" />

        <!-- Dialog Conferma Eliminazione -->
        <v-dialog v-model="dialogElimina" max-width="500" v-if="tipologiaDaEliminare"> -->
            <v-card>
                <v-card-title class="text-h6">
                    Conferma eliminazione
                </v-card-title>
                <v-card-text>
                    <div class="mb-2">
                        Sei sicuro di voler eliminare la tipologia <strong>{{ tipologiaDaEliminare.nome }}</strong>?
                    </div>
                    <v-alert v-if="tipologiaDaEliminare.numeroScadenze > 0" type="warning" dense text class="mt-3">
                        <strong>Attenzione!</strong> Ci sono {{ tipologiaDaEliminare.numeroScadenze }}
                        scadenze associate a questa tipologia.
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="dialogElimina = false">Annulla</v-btn>
                    <v-btn color="error" text @click="eliminaTipologia" :loading="eliminando">
                        Elimina
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog Aggiorna Scadenze Esistenti -->
        <v-dialog v-model="dialogAggiorna" max-width="600" v-if="tipologiaModificata">
            <v-card>
                <v-card-title class="text-h6">
                    Aggiorna scadenze esistenti?
                </v-card-title>
                <v-card-text>
                    <div class="mb-3">
                        Hai modificato i valori di default della tipologia
                        <strong>{{ tipologiaModificata.nome }}</strong>.
                    </div>
                    <div class="mb-3">
                        Ci sono <strong>{{ tipologiaModificata.numeroScadenze }} scadenze</strong>
                        associate a questa tipologia.
                    </div>
                    <div>
                        Vuoi aggiornare anche le scadenze esistenti con i nuovi valori di default?
                    </div>

                    <v-alert type="info" dense text class="mt-4">
                        <strong>Cosa verrà aggiornato:</strong>
                        <ul class="mt-2">
                            <li>Giorni di preavviso</li>
                            <li>Ricorrenza (mesi)</li>
                        </ul>
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="salvaModificaSenzaAggiornamento">
                        No, solo la tipologia
                    </v-btn>
                    <v-btn color="primary" text @click="salvaModificaConAggiornamento">
                        Sì, aggiorna tutto
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Snackbar notifiche -->
        <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="3000">
            {{ snackbar.text }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar.show = false">
                    Chiudi
                </v-btn>
            </template>
        </v-snackbar>
    </v-dialog>
</template>

<script>
import {
    getTipologieScadenze,
    deleteTipologia,
    checkTipologiaUsage,
    updateTipologiaScadenze
} from '@/api/api.scadenze.js';
import TipologiaFormDialog from './TipologiaFormDialog.vue';

export default {
    name: 'GestioneTipologieDialog',

    components: {
        TipologiaFormDialog
    },

    props: {
        value: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            loading: false,
            tipologie: [],
            ricerca: '',

            // Dialog form
            dialogForm: false,
            tipologiaCorrente: null,

            // Dialog eliminazione
            dialogElimina: false,
            tipologiaDaEliminare: null,
            eliminando: false,

            // Dialog aggiornamento scadenze
            dialogAggiorna: false,
            tipologiaModificata: null,

            // Snackbar
            snackbar: {
                show: false,
                text: '',
                color: 'success'
            },

            // Headers tabella
            headers: [
                { text: 'Icona', value: 'icona', sortable: false, width: '80' },
                { text: 'Nome', value: 'nome', sortable: true },
                { text: 'Categoria', value: 'categoria', sortable: true },
                { text: 'Preavviso (gg)', value: 'giorniPreavvisoDefault', sortable: true, align: 'center' },
                { text: 'Ricorrenza', value: 'ricorrenzaMesiDefault', sortable: true, align: 'center' },
                { text: 'Campi Richiesti', value: 'campiRichiesti', sortable: false },
                { text: 'Azioni', value: 'azioni', sortable: false, align: 'center', width: '150' }
            ]
        };
    },

    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },

        tipologieFiltrate() {
            if (!this.ricerca) return this.tipologie;

            const search = this.ricerca.toLowerCase();
            return this.tipologie.filter(t =>
                t.nome.toLowerCase().includes(search) ||
                t.categoria.toLowerCase().includes(search)
            );
        }
    },

    watch: {
        value(val) {
            if (val) {
                this.caricaTipologie();
            }
        }
    },

    methods: {
        async caricaTipologie() {
            this.loading = true;
            try {
                let response = await getTipologieScadenze();
                this.tipologie = response.data.data || response.data || [];
            } catch (error) {
                this.mostraErrore('Errore nel caricamento delle tipologie');
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        nuovaTipologia() {
            this.tipologiaCorrente = null;
            this.dialogForm = true;
        },

        modificaTipologia(tipologia) {
            this.tipologiaCorrente = { ...tipologia };
            this.dialogForm = true;
        },

        async duplicaTipologia(tipologia) {
            const duplicata = {
                ...tipologia,
                id: null,
                nome: '' // Nome resettato come richiesto
            };
            delete duplicata.numeroScadenze;

            this.tipologiaCorrente = duplicata;
            this.dialogForm = true;
        },

        async confermaEliminazione(tipologia) {
            try {
                // Verifica se ci sono scadenze associate
                const response = await checkTipologiaUsage(tipologia.id);
                const numeroScadenze = response.data.data.numeroScadenze || 0;

                this.tipologiaDaEliminare = {
                    ...tipologia,
                    numeroScadenze
                };
                this.dialogElimina = true;
            } catch (error) {
                this.mostraErrore('Errore nella verifica della tipologia');
                console.error(error);
            }
        },

        async eliminaTipologia() {
            this.eliminando = true;
            try {
                await deleteTipologia(this.tipologiaDaEliminare.id);
                this.dialogElimina = false;
                this.tipologiaDaEliminare = null;
                this.mostraSuccesso('Tipologia eliminata con successo');
                await this.caricaTipologie();
            } catch (error) {
                this.mostraErrore('Errore nell\'eliminazione della tipologia');
                console.error(error);
            } finally {
                this.eliminando = false;
            }
        },

        async onTipologiaSalvata(data) {
            // Se è una modifica e ci sono scadenze associate, chiedi se aggiornare
            if (data.isEdit && data.tipologia.id) {
                try {
                    const response = await checkTipologiaUsage(data.tipologia.id);
                    const numeroScadenze = response.data.data.numeroScadenze || 0;

                    if (numeroScadenze > 0) {
                        this.tipologiaModificata = {
                            ...data.tipologia,
                            numeroScadenze,
                            aggiornaScadenze: data.aggiornaScadenze !== false
                        };
                        this.dialogAggiorna = true;
                        return;
                    }
                } catch (error) {
                    console.error('Errore nel controllo scadenze associate:', error);
                }
            }

            // Altrimenti salva direttamente
            this.dialogForm = false;
            this.tipologiaCorrente = null;
            await this.caricaTipologie();
            this.mostraSuccesso(data.isEdit ? 'Tipologia aggiornata con successo' : 'Tipologia creata con successo');
        },

        async salvaModificaSenzaAggiornamento() {
            this.dialogAggiorna = false;
            this.dialogForm = false;
            this.tipologiaCorrente = null;
            await this.caricaTipologie();
            this.mostraSuccesso('Tipologia aggiornata con successo');
        },

        async salvaModificaConAggiornamento() {
            try {
                await updateTipologiaScadenze(this.tipologiaModificata.id, true);
                this.dialogAggiorna = false;
                this.dialogForm = false;
                this.tipologiaCorrente = null;
                await this.caricaTipologie();
                this.mostraSuccesso('Tipologia e scadenze aggiornate con successo');
            } catch (error) {
                this.mostraErrore('Errore nell\'aggiornamento delle scadenze');
                console.error(error);
            }
        },

        parseCampiRichiesti(campiRichiestiJson) {
            try {
                return JSON.parse(campiRichiestiJson || '[]');
            } catch {
                return [];
            }
        },

        getCampoLabel(campo) {
            const labels = {
                targa: 'Targa',
                nomePc: 'PC',
                operatore: 'Operatore'
            };
            return labels[campo] || campo;
        },

        chiudi() {
            this.dialog = false;
            this.$emit('close');
        },

        mostraSuccesso(text) {
            this.snackbar = { show: true, text, color: 'success' };
        },

        mostraErrore(text) {
            this.snackbar = { show: true, text, color: 'error' };
        }
    }
};
</script>